import { getFormDefinition, createFormDataFromItem, createItemFromFormData } from './form';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';
import { validatorRequire } from '@/utils/validators';

export default {
  computed: {
    definition() {
      return this.createDefinition();
    },
    entityStore() {
      return entityToStore(this.entity);
    },
    ownProductYN() {
      return this.$store.getters['editor/value']('ownProductYN');
    },
    measurementRequired() {
      return this.measurementIsRequired();
    },
    vatTypes() {
      return this.$store.getters['vatType/loadedItems'].map(e => {
        const option = this.$store.getters['option/loadedOptions']('vatType').find(
          item => item.code === e.vatTypeOption
        );
        return { id: e.id, name: option && option.description };
      });
    }
  },
  watch: {
    measurementRequired(measurementIsRequired) {
      if (measurementIsRequired) {
        this.definition.measurementInMm.rules = [{ validator: validatorRequire }];
      } else {
        this.definition.measurementInMm.rules = [];
      }
    },
    ownProductYN(isOwnProduct) {
      if (!isOwnProduct) {
        this.definition.domainID.rules = [{ validator: validatorRequire }];
      } else {
        this.definition.domainID.rules = [];
      }
    }
  },
  mixins: [baseCrudMixin],
  data: () => ({
    entity: 'Product',
    returnTo: 'Products'
  }),
  created() {
    this.$store.dispatch('vatType/getItems');
    this.$store.dispatch('productType/getItems');
  },
  methods: {
    createDefinition() {
      return getFormDefinition(this);
    },
    measurementIsRequired() {
      const productType = this.$store.getters['productType/getLoadedItemByID'](this.$route.params.id);
      return !!(productType && productType.measurementRequiredYN);
    },
    createFormDataFromItem,
    createItemFromFormData
  }
};
